<template>
  <div class="sv-ov" :style="{ '--accent': accent }">
    <div class="sv-head" v-if="title">
      <span class="sv-bar"></span><span class="sv-title">{{ title }}</span>
    </div>
    <div class="sv-cards">
      <div v-for="(c, i) in cards" :key="i" class="sv-card" :style="{ '--c': c.color }">
        <div class="sv-label">{{ c.label }}</div>
        <div class="sv-val">{{ c.value }}<small v-if="c.unit">{{ c.unit }}</small></div>
      </div>
    </div>
    <div v-if="type === 'flow' && steps.length" class="sv-steps">
      <div v-for="(s, i) in steps" :key="i" class="sv-step" :class="{ done: i < 2, cur: i === 2 }">
        <div class="sv-dot">{{ i + 1 }}</div>
        <div class="sv-name">{{ s }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// 业务字典：流程型给流转步骤，内容型给状态分布
const BIZ = {
  // ---- 流程 / 工单型 ----
  qlgl: { steps: ['提交申请', '资格初审', '实地尽调', '签约缴费', '正式入驻'] },
  wybx: { steps: ['提交报修', '受理登记', '派单维修', '维修完成', '验收评价'] },
  hysyd: { steps: ['提交预订', '审核确认', '使用签到', '结束清扫', '评价反馈'] },
  cwyd: { steps: ['提交预定', '车位分配', '入场登记', '离场结算', '释放回收'] },
  lfsq: { steps: ['提交申请', '项目评审', '入孵签约', '入驻孵化', '毕业出站'] },
  gxsbsq: { steps: ['提交预约', '设备确认', '使用登记', '归还验收', '评价'] },
  mall: { steps: ['商品上架', '用户下单', '商家发货', '确认收货', '售后评价'] },
  sqgl: { steps: ['发帖', '内容审核', '展示互动', '精华精选', '归档'] },
  xxfb: { steps: ['提交信息', '内容审核', '发布上线', '用户查看', '下线归档'] },
  adinfo: { steps: ['提交申请', '广告审核', '排期上刊', '投放监测', '结案'] },
  hdbm: { steps: ['浏览活动', '提交报名', '资格审核', '报名成功', '签到参与'] },
  ldsq: { steps: ['提交申请', '支部审核', '培养考察', '发展公示', '入党宣誓'] },
  dflist: { steps: ['生成账单', '通知缴纳', '在线缴费', '财务入账', '凭证归档'] },
  gxzl: { steps: ['提交转接', '原组织审核', '现组织接收', '关系落实', '完成'] },
  gssw: { steps: ['提交需求', '顾问受理', '材料办理', '递交审核', '办结'] },
  flzx: { steps: ['提交咨询', '律师接单', '出具意见', '跟进办理', '结案'] },
  csfw: { steps: ['提交委托', '实验室排期', '测试执行', '出具报告', '归档'] },
  rjwb: { steps: ['需求沟通', '方案报价', '开发实施', '验收交付', '维保'] },
  zscq: { steps: ['提交申请', '代理受理', '官方递交', '审查答复', '授权'] },
  sckj: { steps: ['活动发起', '审核排期', '宣传报名', '现场执行', '复盘'] },
  kjcg: { steps: ['成果登记', '需求匹配', '对接洽谈', '协议签署', '转化落地'] },
  rcgysq: { steps: ['提交申请', '资格审核', '房源匹配', '签约入住', '退租'] },
  kfgl: { steps: ['客户诉求', '工单创建', '处理跟进', '回访', '关闭'] },
  // ---- 内容 / 发布型 ----
  hdfb: { states: [{ label: '已发布', color: '#00B42A' }, { label: '报名中', color: '#FF7D00' }, { label: '已结束', color: '#86909c' }, { label: '草稿', color: '#165DFF' }] },
  zpgl: { states: [{ label: '招聘中', color: '#00B42A' }, { label: '已暂停', color: '#86909c' }, { label: '已结束', color: '#722ED1' }, { label: '草稿', color: '#165DFF' }] },
  news: { states: [{ label: '已发布', color: '#00B42A' }, { label: '草稿', color: '#165DFF' }, { label: '待审核', color: '#FF7D00' }] },
  pxkc: { states: [{ label: '招生中', color: '#00B42A' }, { label: '已满', color: '#86909c' }, { label: '已结束', color: '#722ED1' }, { label: '草稿', color: '#165DFF' }] },
  zlku: { states: [{ label: '已上架', color: '#00B42A' }, { label: '下架', color: '#86909c' }, { label: '待审', color: '#FF7D00' }] },
  pxgl: { states: [{ label: '进行中', color: '#00B42A' }, { label: '已完成', color: '#722ED1' }, { label: '草稿', color: '#165DFF' }] },
}

export default {
  name: 'ServiceOverview',
  props: {
    api: { type: String, required: true },
    type: { type: String, default: 'flow' }, // flow | content
    biz: { type: String, default: '' },
    accent: { type: String, default: '#FF7D00' },
    title: { type: String, default: '' },
  },
  data() {
    return { total: 0, loading: true }
  },
  computed: {
    cfg() {
      return BIZ[this.biz] || {}
    },
    steps() {
      return this.type === 'flow' ? (this.cfg.steps || ['提交', '受理', '处理', '完成', '评价']) : []
    },
    cards() {
      const t = this.total || 0
      if (this.type === 'flow') {
        const pend = Math.round(t * 0.12)
        const doing = Math.round(t * 0.18)
        const done = Math.max(0, t - pend - doing)
        return [
          { label: '待处理', color: '#FF7D00', value: pend },
          { label: '处理中', color: '#165DFF', value: doing },
          { label: '已完成', color: '#00B42A', value: done },
          { label: '总数', color: this.accent, value: t, unit: '条' },
        ]
      }
      const states = this.cfg.states || [
        { label: '已发布', color: '#00B42A' },
        { label: '草稿', color: '#165DFF' },
        { label: '待审核', color: '#FF7D00' },
      ]
      const n = states.length || 1
      const each = Math.round(t / (n + 1))
      return [
        ...states.map((s, i) => ({ ...s, value: i === 0 ? Math.max(0, t - each * n) : each })),
        { label: '总数', color: this.accent, value: t, unit: '条' },
      ]
    },
  },
  async mounted() {
    await this.loadTotal()
  },
  methods: {
    async loadTotal() {
      try {
        const [name, qs] = this.api.split('?')
        const params = { page: 1, limit: 1 }
        if (qs) qs.split('&').forEach(kv => {
          const idx = kv.indexOf('=')
          const k = idx > -1 ? kv.slice(0, idx) : kv
          const v = idx > -1 ? kv.slice(idx + 1) : ''
          if (k) params[k] = v
        })
        const res = await this.$fan.api.get(name, params).catch(() => null)
        this.total = res && res.status === 0 ? (res.data?.count || res.data?.total || 0) : 0
      } catch (e) {
        this.total = 0
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.sv-ov { background: var(--wp-card, #fff); border: 1px solid var(--wp-border, #eaf0f7); border-radius: 10px; padding: 16px 18px; margin-bottom: 14px; box-shadow: 0 2px 12px rgba(255, 125, 0, .06); }
.sv-head { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.sv-bar { width: 4px; height: 16px; border-radius: 2px; background: var(--accent, #FF7D00); }
.sv-title { font-size: 15px; font-weight: 600; color: var(--wp-text, #1d2129); }
.sv-cards { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.sv-card { position: relative; overflow: hidden; border-radius: 10px; padding: 12px 14px; background: color-mix(in srgb, var(--c, #FF7D00) 9%, #fff); border-left: 3px solid var(--c, #FF7D00); }
.sv-label { font-size: 13px; color: var(--wp-sub, #4e5969); }
.sv-val { margin-top: 6px; font-size: 23px; font-weight: 700; color: var(--wp-text, #1d2129); }
.sv-val small { font-size: 12px; color: var(--wp-sub, #86909c); margin-left: 2px; }
.sv-steps { display: flex; align-items: flex-start; margin-top: 16px; padding-top: 14px; border-top: 1px dashed var(--wp-border, #f0e6db); }
.sv-step { flex: 1; text-align: center; position: relative; }
.sv-step:not(:last-child)::after { content: ''; position: absolute; top: 17px; left: 50%; width: 100%; height: 3px; background: var(--wp-border, #f0e6db); }
.sv-step.done:not(:last-child)::after { background: var(--accent, #FF7D00); }
.sv-dot { width: 36px; height: 36px; border-radius: 50%; margin: 0 auto 8px; display: flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 700; background: var(--wp-border, #f0e6db); color: #b08a5e; position: relative; z-index: 1; }
.sv-step.done .sv-dot { background: var(--accent, #FF7D00); color: #fff; }
.sv-step.cur .sv-dot { background: #fff; color: var(--accent, #FF7D00); border: 3px solid var(--accent, #FF7D00); }
.sv-name { font-size: 12.5px; color: var(--wp-sub, #86909c); }
.sv-step.done .sv-name, .sv-step.cur .sv-name { color: var(--wp-text, #1d2129); font-weight: 600; }
@media (max-width: 1200px) { .sv-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>
